import { COVER_IMAGE_RATIO } from '../../CoverImage';

import { ENTRY_CARD_GAP, ENTRY_CARD_PADDING } from './EntryCardContainer';

const ENTRY_CARD_VALUES_PADDING = 4;
const ENTRY_CARD_VALUES_GAP = 12;

export const CONTAINER_PADDING = 5;

/**
 * Makes a prediction about how many pixels high an entry card will be.
 */
export function getEntryCardHeightPrediction({
  cardWidth,
  fieldCount,
  hasCover,
}: {
  cardWidth: number;
  fieldCount: number;
  hasCover: boolean;
}): number {
  return (
    ENTRY_CARD_PADDING * 2 +
    (hasCover
      ? (cardWidth * COVER_IMAGE_RATIO[1]) / COVER_IMAGE_RATIO[0] + ENTRY_CARD_GAP
      : 0) +
    ENTRY_CARD_VALUES_PADDING * 2 +
    fieldCount * 20 +
    Math.max(fieldCount - 1, 0) * ENTRY_CARD_VALUES_GAP
  );
}
